import priceString from '@utils/price-string';
import { context as defaultContext } from './mini-cart-defaults';
import template, { listItem } from './templates/mini-cart-line';
import store from '@stores/cart/cart-store';
import { exceptionBehaviorValues } from '../../stores/cart/cart-store';

const DEFAULT_OPTIONS = {
    replaceOriginEl: false
};

export default class MiniCartLine {
    constructor($originEl, context, data, options) {
        options = { ...DEFAULT_OPTIONS, ...options };

        this.context = { ...defaultContext, ...context };

        const $parsed = $( $.parseHTML(template) );
        this.$el = $parsed;
        this.$originEl = $originEl;

        this.$quantityLabel = this.$el.find('[data-label="quantity"]');
        this.$removeLabel = this.$el.find('[data-label="remove"]');

        this.$attributes = this.$el.find('[data-region="attributes"]');
        this.$autoship = this.$el.find('[data-region="autoship"]');
        this.$autoshipIcon = this.$el.find('[data-region="autoshipIcon"]');
        this.$image = this.$el.find('[data-region="image"]');
        this.$name = this.$el.find('[data-region="name"]');
        this.$link = this.$el.find('[data-region="link"]');
        this.$price = this.$el.find('[data-region="price"]');
        this.$strikethrough = this.$el.find('[data-region="strikethrough"]');
        this.$quantity = this.$el.find('[data-region="quantity"]');
        this.$subscribe = this.$el.find('[data-region="subscribe"]');

        this.$removeCtrl = this.$el.find('[data-control="remove"]');

        // backorder
        this.$outofstockLabel = this.$el.find('[data-label="outofstock"]');
        this.$outofstockIcon = this.$el.find('[data-label="outofstockicon"]');
        this.$outofstockRegion = this.$el.find('[data-region="outofstockregion"]');

        this.data = data || {};
        this.lineId = data.lineId;

        console.log('data1', data);
        console.log('data2', data.backOrdered);
        this.backorder = data.backOrdered;
        console.log('data3', this.backorder);

    }

    init()  {
        this.renderLabels();
        this.renderRegions();
        this.setupListeners();
    }

    onRemove() {
        store.actions.removeLine(this.lineId);
    }

    renderAttributes() {
        const attrs = store.getters.lineAttributes(this.lineId, {
            flavor: this.context.Flavor,
            packaging: this.context.Packaging,
            strengthSize: this.context.StrengthSize,
            strengthSizeSupplies: this.context.StrengthSizeSupplies,
            rxForm: this.context.RxForm
        });

        let attrsHtmlStr =
            attrs
                .map((attr) => listItem(attr.label, attr.value))
                .join('');

        const parsed = $.parseHTML(attrsHtmlStr);
        this.$attributes.html(parsed);
    }

    renderAutoship() {
        const iconUrl = this.context.AutoshipIcon;

        if(iconUrl) {
            const icon = document.createElement('img');
            icon.src = iconUrl;
            icon.alt = '';
            icon.setAttribute('aria-hidden', true);
            this.$autoshipIcon.html(icon);
        } else {
            this.$autoshipIcon.hide();
        }

        this.$subscribe.html(this.context.Subscribe);

        this.updateAutoship();
    }

    renderDetails() {
        const formattedPrice = priceString(this.data.listPrice);
        const formattedExceptionPrice = priceString(this.data.exceptionAmount);

        switch(this.data.exceptionBehavior) {
            case exceptionBehaviorValues.STRIKE_THROUGH:
                this.$price.html(formattedExceptionPrice);
                this.$strikethrough.html(formattedPrice);
                break;
            case exceptionBehaviorValues.REPLACE:
                this.$price.html(formattedExceptionPrice);
                this.$strikethrough.hide();
                break;
            default:
                this.$price.html(formattedPrice);
                this.$strikethrough.hide();
        }

        this.$quantity.html(this.data.quantity);
    }

    renderImages() {
        const imageUrl = this.data.image?.constrainedUrl;
        if(imageUrl) {
            const img = document.createElement('img');
            img.src = imageUrl;
            img.alt = this.data.image.alt;

            this.$image.html(img);
        }
    }

    renderLabels() {
        this.$quantityLabel.html(this.context.Quantity);
        this.$removeLabel.html(this.context.Remove);

        if(!this.backorder){
            this.$outofstockRegion.hide();
        }
        if(this.backorder){
            this.$removeLabel.addClass('text-color-vca-red');
        }
        this.$outofstockLabel.html(this.context.OutOfStock);
        let img = document.createElement('img');
        img.src = this.context.OutOfStockIcon;
        this.$outofstockIcon.html(img);
    }

    renderRegions() {
        this.$name.html(this.data.displayName);

        if(this.$link.is('a')) {
            this.$link.attr('href', this.data.productUrl);
        }

        this.renderAutoship();
        this.renderAttributes();
        this.renderDetails();
        this.renderImages();
    }

    setupListeners() {
        this.$removeCtrl.on('click', () => this.onRemove());
    }

    update(line) {
        const isAutoshipUpdated = this.data.autoshipFrequency !== line.autoshipFrequency;
        const isQtyUpdated = this.data.quantity !== line.quantity;

        this.data = line;

        if(isAutoshipUpdated)
            this.updateAutoship();
        if(isQtyUpdated)
            this.renderDetails();
    }

    updateAutoship() {
        if(this.data.autoshipFrequency) {
            this.$autoship.show();
        } else {
            this.$autoship.hide();
        }
    }
}
